import { render, staticRenderFns } from "./CapLogs.vue?vue&type=template&id=bd983cba&scoped=true&"
import script from "./CapLogs.vue?vue&type=script&lang=js&"
export * from "./CapLogs.vue?vue&type=script&lang=js&"
import style0 from "./CapLogs.vue?vue&type=style&index=0&id=bd983cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd983cba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/idev/ui_projects/vue/training/topnav-auth-skeleton-1/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VFooter,VLayout})
